import type { TravelFeatureConfig } from '../../../types/insurances/TravelFeatureConfig';

export const travel: TravelFeatureConfig = {
    overview: {
        details: {
            showContractedInsurances: true,
            showVariant: true,
            showPackage: false,
            showStartDateWithTime: false,
            showContractHolder: true,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
        showLinkedCards: true,
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
